export class MonthDay {
    month: number;
    dayOfMonth: number;

    constructor(month: number, dayOfMonth: number) {
        this.month = month;
        this.dayOfMonth = dayOfMonth;
    }
}
